import { makeStyles } from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { CONSTANTS, THEME } from 'constants/index';
import styled from 'styled-components';


export const InvoiceDialogContent = styled(DialogContent)`
  padding: 0 32px;
  overflow: hidden;
`;


export const InvoiceDialogTitle = styled(DialogTitle)`
  padding-bottom: 8px;
  padding-left: 0;
  margin: 0 32px;
  border-bottom: 1px solid ${THEME.muiBorderGrey};
`;

export const InvoiceProducts = styled.p`
  margin: 24px 0 24px 0;
  font-weight: 300;
  font-size: 18px;
  line-height: 21px;
  color: ${THEME.bobBlack};
`;

export const InvoiceProductName = styled.p`
  margin: 8px 0 0 0;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: ${THEME.grey};
`;

const baseText = styled.p`
  margin: 0;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: ${THEME.grey};
`;

export const InvoiceTotal = baseText;

export const InvoiceBags = styled(baseText)`
  font-weight: normal;
  color: ${THEME.grey};
`;

export const InvoiceBagsQuantity = styled(InvoiceBags)`
  display: inline-block;
  font-weight: bold;
  margin-right: 0.25em;
  color: ${THEME.grey};
  &::after {
    content:"x";
  };
`;

export const InvoicePrice = styled(baseText)`
  color: ${THEME.bobBlack};
  &::after {
    content:"${CONSTANTS.CURRENCY}";
  }
`;

export const InvoiceLine = styled.div`
  padding: 9px 0 0 0;
  display: flex;
  justify-content: space-between;
  ${props => props.isTotal && `
  border-top: 1px solid ${THEME.muiBorderGrey};
  margin: 9px 0 0 0;
  `}
  ${props => props.isLast && `
  border-bottom: 1px solid ${THEME.muiBorderGrey};
  padding: 9px 0 9px 0;
  `}
  ${props => props.isFirst && `
  margin-top: 15px;
  `}  
`;

export const useInvoiceStyle = makeStyles(theme => ({
  root: {
    '& div.MuiDialogContent-root': {
      minWidth                    : '0px',
      [theme.breakpoints.up('sm')]: {
        minWidth: '576px',
      },
    },
  },
  dialogActions: {
    display       : 'flex',
    justifyContent: 'space-between',
    padding       : '32px 8px',
    width         : '100%',

    [theme.breakpoints.up('sm')]: {
      padding: '32px 28px',
    },

    '& button, a': {
      fontWeight: 'bold',
      fontSize  : '14px',
      margin    : 0,
    },
    '& a.invoice-button-stripe-disabled': {
      textDecoration: 'line-through',
      cursor        : 'notAllowed',
      pointerEvents : 'initial',
      transition    : 'none',
      boxShadow     : 'none',
    },
  },
}));
